export default "__VITE_ASSET__CY3QEZ3d__"